
import CloseCircle from "../../../assets/filled/CloseCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloseCircleIcon({ className, dataTestid = "CloseCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloseCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
